import { render, staticRenderFns } from "./EditInsurance.vue?vue&type=template&id=13fcdd58&scoped=true"
import script from "./EditInsurance.vue?vue&type=script&lang=js"
export * from "./EditInsurance.vue?vue&type=script&lang=js"
import style0 from "./EditInsurance.vue?vue&type=style&index=0&id=13fcdd58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13fcdd58",
  null
  
)

export default component.exports